import React from 'react';
import { ShieldCheck, Landmark, Lock } from 'lucide-react';

export const UniversalBenefitsSection = () => {
  return (
    <section id="beneficios-todos" className="py-20 bg-black" data-testid="universal-benefits-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <ShieldCheck className="h-8 w-8 text-yellow-400" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Beneficios para todos
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
            Cuentas con secreto bancario reforzado y soberanía financiera total, y operamos bajo
            estrictos estándares de privacidad, lejos de la burocracia.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div className="flex items-start space-x-4 bg-slate-900 border border-slate-800 rounded-2xl p-6">
            <div className="w-12 h-12 flex-shrink-0 bg-yellow-500/20 rounded-full flex items-center justify-center">
              <Lock className="h-6 w-6 text-yellow-400" />
            </div>
            <div>
              <h3 className="text-lg font-bold text-white mb-2">Secreto bancario reforzado</h3>
              <p className="text-slate-300 leading-relaxed">
                Operamos bajo estrictos estándares de privacidad para proteger tu información en cada operación.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-4 bg-slate-900 border border-slate-800 rounded-2xl p-6">
            <div className="w-12 h-12 flex-shrink-0 bg-yellow-500/20 rounded-full flex items-center justify-center">
              <Landmark className="h-6 w-6 text-yellow-400" />
            </div>
            <div>
              <h3 className="text-lg font-bold text-white mb-2">Soberanía financiera total</h3>
              <p className="text-slate-300 leading-relaxed">
                Control absoluto sobre tu dinero, sin trabas burocráticas y con la libertad que mereces.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
